<template>
  <intersect @enter="animate = true">
    <div
            class="reasonsSliderContainer container usefullToolscontainer "
            v-if="itemData"
            :class="bg"
    >
      <div class="mainTtl noto-semibold" v-if="_.get(itemData, 'useHeader') == 1">
        {{ _.get(itemData, "header.title") }}
      </div>
      <div class="descr" v-if="_.get(itemData, 'header')">
        {{ _.get(itemData, "header.teaser") }}
      </div>
      <swiper
              class="usefulToolsSlider fadeUp"
              :class="animate ? 'animate' : ''"
              ref="usefulToolsSlider"
              :options="swiperOptions"
      >

        <template v-for="(item, index) in _.get($store.state.indx, 'menu_tools')" v-if="_.get(itemData, index) && _.get(itemData, index)!=0">
          <swiper-slide :key="index">
              <a :target="_.get(item, 'button.targetblank') ? '_blank' : ''" :href="_.get(item, 'button.url')" @click="$store.commit('setStateDeep', { key: 'loader.'+item.title, val: _.get(itemData, index), })" class="usefullTool" >
              <div class="inner">
                <span v-if="_.get(item, 'button.svg')" v-html="_.get(item, 'button.svg')"></span>
                <div class="ttl noto-semibold">{{ $fn.tr(_.get(item, 'button.title')) }}</div>
              </div>
              <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="5.844"
                      height="9.566"
                      viewBox="0 0 5.844 9.566"
              >
                <g
                        id="Group_1006"
                        data-name="Group 1006"
                        transform="translate(42.561 -19638.994) rotate(-90)"
                >
                  <path
                          id="Path_61"
                          data-name="Path 61"
                          d="M0,3.722,3.722,0"
                          transform="translate(-19643.777 -41.5)"
                          fill="none"
                          stroke="#444958"
                          stroke-linecap="round"
                          stroke-width="1.5"
                  />
                  <path
                          id="Path_60"
                          data-name="Path 60"
                          d="M3.722,3.722,0,0"
                          transform="translate(-19647.5 -41.5)"
                          fill="none"
                          stroke="#444958"
                          stroke-linecap="round"
                          stroke-width="1.5"
                  />
                </g>
              </svg>
            </a>

          </swiper-slide>
        </template>

      </swiper>


      <portal to="popup" v-if="_.get($store.state.loader, 'loan_calculator' )">
        <CalculatorLoans :calcType="'1'" />
      </portal>
      <portal to="popup" v-if="_.get($store.state.loader, 'deposit_calculator' )">
        <CalculatorDeposit :calcType="'1'" />
      </portal>
      <portal to="popup" v-if="_.get($store.state.loader, 'stock_calculator' )">
        <CalculatorStock :calcType="'1'" />
      </portal>
      <portal to="popup" v-if="_.get($store.state.loader, 'mortgage_calculator' )">
        <CalculatorMortgage :calcType="'1'" />
      </portal>

      <CompareProducts v-if="_.get($store.state.loader, 'compare_products' )" />

    </div>
  </intersect>
</template>

<script>
  import CalculatorLoans from "@/components/CalculatorLoans";
  import CalculatorDeposit from "@/components/CalculatorDeposit";
  import CalculatorStock from "@/components/CalculatorStock";
  import CalculatorMortgage from "@/components/CalculatorMortgage";
  import CompareProducts from "@/components/CompareProducts";
  import mainMixin from "@/mixins/main";
  import Intersect from 'vue-intersect'
  export default {
    props: ["itemData", "bg", "firstLook", "ipadLook"],
    mixins: [mainMixin],
    data() {
      return {
        animate: false,
        swiperOptions: {
          speed: 800,
          watchOverflow: true,
          breakpoints: {
            320: {
              spaceBetween: 15,
              slidesPerView: _.size(_.get(this.$store.state.indx, 'menu_tools')) > 1 ? 1.3 : 1,
            },
            450: {
              spaceBetween: 15,
              slidesPerView: 1.5,
            },
            768: {
              spaceBetween: 15,
              slidesPerView: 2.5,
            },
            1440: {
              spaceBetween: 15,
              slidesPerView: 3.3,
            },
            1640: {
              spaceBetween: 15,
              slidesPerView: 4,
            },
          },
        },
      };
    },
    components: {
      CalculatorLoans,
      CalculatorDeposit,
      CalculatorStock,
      CalculatorMortgage,
      CompareProducts,
      Intersect
    },
    computed: {
      getUsefulTools() {
        return this.$store.getters.getUsefulTools;
      },
      swiper() {
        return this.$refs.usefulToolsSlider.$swiper;
      },
    },
  };
</script>
